import { IAppEntity } from "../../entities";
import React from "react";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { CreateIncomingBankPaymentDto } from "../../../components/Pages/Documents/IncomingBanks/dtos/CreateIncomingBankPaymentDto";
import { IncomingBankPaymentService } from "../../../services/documents/IncomingBankPaymentService";
import { NFLookupIncomingBankPayments } from "../../../components/Shared/NewForms/NFLookupIncomingBankPayments";
import IncomingBanksList from "src/components/Pages/Documents/IncomingBanks/components/IncomingBanksList";
import { IncomingBanksDetail } from "src/components/Pages/Documents/IncomingBanks/components/IncomingBanksDetail";
import { IncomingBankPaymentOperationTypeEnum } from "src/components/Pages/Documents/IncomingBanks/dtos/IncomingBankPaymentOperationTypeEnum";

export const IncomingBankPayments: IAppEntity = {
  entityType: "document",
  title: "Incoming Banks",
  pluralTitle: "Incoming bank payments",
  apiUrl: "IncomingBankPayments",
  apiEnum: ReferenceTypes.DocumentIncomingBankPayment,
  getDetailView: (id?: string) => {
    return React.createElement(IncomingBanksDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),

  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(IncomingBanksList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupIncomingBankPayments, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new IncomingBankPaymentService("IncomingBankPayments"),
  getEmptyModel: () => {
    const model: CreateIncomingBankPaymentDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,

      processedDate: new Date(),
      documentDate: new Date(),
      createdDate: new Date(),
      operationType: IncomingBankPaymentOperationTypeEnum.CustomerPayment,
      comment: "",
      payments: []
    };
    return model;
  }
};
